import React from "react";
import Question from "./Question";
import StructuredDataTag from "../Various/Seo/StructuredDataTag";
import { useTranslation } from "next-i18next";
import BrandButton from "@components/Various/BrandButton";
import MutedText from "@components/Various/MutedText";

type Question = {
  question: string;
  answer: string;
};

function FAQ() {
  const { t } = useTranslation("faq");

  const questions =
    (t("questions", { returnObjects: true }) as Question[]) || [];
  const questionsStructuredData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: questions.map((question) => ({
      "@type": "Question",
      name: question.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: question.answer,
      },
    })),
  };

  return (
    <section className="py-12 bg-white sm:py-16 lg:py-20">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl xl:text-5xl font-pj">
            {t("title")}
          </h2>
          <p className="max-w-lg mx-auto mt-6 text-base text-gray-600 font-pj"></p>
        </div>
        <div className="grid max-w-5xl grid-cols-1 mx-auto mt-10 sm:mt-20 md:grid-cols-2 md:gap-x-16 gap-y-8 md:gap-y-12">
          {questions.map(({ question, answer }) => (
            <Question key={question} question={question} answer={answer} />
          ))}

          <StructuredDataTag data={questionsStructuredData} />
        </div>

        <div className="max-w-lg text-center flex flex-col gap-3 mx-auto mt-6">
          <MutedText>{t("questions-left")}</MutedText>

          <a href="https://help.smarketer.jobs/">
            <BrandButton>{t("open-kb")}</BrandButton>
          </a>
        </div>
      </div>
    </section>
  );
}

export default FAQ;
